import React from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';

import IconInfoOrenge from '../assets/images/common/icon-info-orange.svg';
import IconMailWihte from '../assets/images/common/icon-mail-wihte.svg';

type ErrorModalProps = {
    openState: boolean; // モーダル開閉値
    setOpenState: (value: boolean) => void; // モーダル開閉管理setState
    errorMessages: Array<string>; // エラーメッセージ
    contactShow?: boolean; // お問い合わせフォーム表示判定
    contactShowErrorMessage?: string; // お問い合わせフォーム表示エラーメッセージ
};

// エラーモーダル表示
export const ErrorModalModal: React.FC<ErrorModalProps> = ({
    openState,
    setOpenState,
    errorMessages,
    contactShow,
    contactShowErrorMessage,
}) => {
    return (
        <Modal
            isOpen={openState}
            onAfterOpen={() => setOpenState(true)}
            onRequestClose={() => setOpenState(false)}
            className={'modal-card'}
            id={'modal-error'}
            overlayClassName={'modal-overlay'}
            ariaHideApp={false}
        >
            <header className='modal-card-head'>
                <p className='modal-card-title'>制限事項</p>
                <button className='delete' aria-label='close' onClick={() => setOpenState(false)}>
                    <span>CLOSE</span>
                </button>
            </header>
            <section className='modal-card-body'>
                <div className='content'>
                    {errorMessages.map((message, index) => (
                        <React.Fragment key={`errModal-message-${index}`}>
                            <div className='columns'>
                                <div className='column'>
                                    <div className='alert_box'>
                                        <span className='icon'>
                                            <img src={IconInfoOrenge} alt='' />
                                        </span>
                                        <span className='text'>{message}</span>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    ))}
                    {contactShow && (
                        <div className='columns'>
                            <div className='column'>
                                <div className='modal_info'>
                                    <p className='has-text-centered-tablet'>{contactShowErrorMessage}</p>
                                    <div className='is-flex is-justify-content-center'>
                                        <Link to='/contact/error' className='button is-dl_blue'>
                                            <span>お問い合わせフォーム</span>
                                            <span className='icon is-small'>
                                                <img src={IconMailWihte} alt='' />
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </Modal>
    );
};
